import { Button, Group, Label, ListBox, ListBoxItem, Popover, Select, SelectValue } from '@launchpad-ui/components';

import { Flex } from '../../../shared/components';
import { formatSubscriptionState, SubscriptionState } from '../../model';

import './SubscriptionStateSelect.scss';

export function SubscriptionStateSelect({
  subStateFilter,
  setSubStateFilter,
}: {
  subStateFilter: SubscriptionState | undefined;
  setSubStateFilter: (item?: SubscriptionState) => void;
}) {
  const handleSelectionChange = (key: string | number | null) => {
    const value = key as string;
    const filter = value === 'all' ? undefined : (value as SubscriptionState);
    setSubStateFilter(filter);
  };

  return (
    <Flex>
      <div className="SubscriptionFilter">
        <Group className="subscription-filter__field">
          <Label>Subscription state:</Label>
          <Select
            value={subStateFilter || 'all'}
            onChange={handleSelectionChange}
            className="subscription-filter__select"
            aria-label="Filter by subscription state"
          >
            <Button>
              <SelectValue />
            </Button>
            <Popover>
              <ListBox>
                <ListBoxItem id="all" textValue="All">
                  All
                </ListBoxItem>
                {Object.values(SubscriptionState).map((state) => (
                  <ListBoxItem key={state} id={state} textValue={formatSubscriptionState(state)}>
                    {formatSubscriptionState(state)}
                  </ListBoxItem>
                ))}
              </ListBox>
            </Popover>
          </Select>
        </Group>
      </div>
    </Flex>
  );
}
